"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const React = require("react");
const theme_1 = require("../modules/theme");
const test_1 = require("../modules/test");
const react_native_1 = require("react-native");
const layout_1 = require("../modules/layout");
class Button extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const { disabledBackgroundColor, disabledLabelColor } = this.props;
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                touchable: {
                    backgroundColor: theme.backgroundColor1,
                    borderColor: theme.borderColor1,
                    borderWidth: 1,
                    borderRadius: 3,
                    height: (0, layout_1.isTablet)() ? 45 : 40,
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                touchablePrimary: {
                    backgroundColor: theme.backgroundColor3,
                    borderWidth: 0
                },
                text: {
                    fontFamily: theme.fontFamily1,
                    fontSize: (0, layout_1.isTablet)() ? 18 : 13,
                    paddingHorizontal: 11,
                    color: theme.textColor1
                },
                textPrimary: {
                    color: theme.textColor4
                },
                disabled: {
                    backgroundColor: disabledBackgroundColor != null
                        ? disabledBackgroundColor
                        : theme.backgroundColor2
                },
                textDisabled: {
                    color: disabledLabelColor != null ? disabledLabelColor : 'silver'
                }
            });
            return styles;
        };
    }
    render() {
        const { text, primary, style, textStyle, onPress, disabled, nativeID } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.7, style: [
                styles.touchable,
                primary && styles.touchablePrimary,
                style,
                disabled && styles.disabled
            ], onPress: onPress, disabled: disabled, testID: (0, test_1.getTestID)(nativeID) },
            React.createElement(react_native_1.Text, { nativeID: nativeID, style: [
                    styles.text,
                    primary && styles.textPrimary,
                    textStyle,
                    disabled && styles.textDisabled
                ] }, text)));
    }
}
exports.Button = Button;
Button.defaultProps = {
    primary: true
};
